document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('#shopify-section-template--29530802782547__section_V89i3K');
  if (!section) return;

  section.querySelectorAll('.divider').forEach(divider => {
    divider.remove();
  });

  const iconBlocks = section.querySelectorAll('.shopify-block.icon-block');
  if (iconBlocks.length) {
    const outerBlocks = [...iconBlocks].map(el => el.closest('[data-testid="group-block"]')).filter(Boolean);
    if (outerBlocks.length) {
      const wrapper = document.createElement('div');
      wrapper.style.cssText = 'display: flex; flex-direction: row; flex-wrap: nowrap; justify-content: center; text-align: center; gap: 6px; width: 100%;';
      outerBlocks[0].parentNode.insertBefore(wrapper, outerBlocks[0]);
      outerBlocks.forEach(block => wrapper.appendChild(block));
    }
  }

  if (window.innerWidth > 768) return;

  section.querySelectorAll('.shopify-block.icon-block').forEach(iconBlock => {
    const parent = iconBlock.closest('.group-block-content');
    if (parent) {
      parent.style.flexDirection = 'column';
      parent.style.alignItems = 'center';
      parent.style.textAlign = 'center';
      parent.style.gap = '4px';

      const h4 = parent.querySelector('h4');
      if (h4) {
        h4.style.fontSize = '0.7rem';
        h4.style.lineHeight = '1.4';
        h4.style.marginTop = '4px';
        h4.style.textAlign = 'center';
      }
    }

    const outerBlock = iconBlock.closest('[data-testid="group-block"]');
    if (outerBlock) {
      outerBlock.style.width = '30%';
      outerBlock.style.minWidth = '30%';
      outerBlock.style.flexShrink = '0';
      outerBlock.style.paddingInlineStart = '0px';
    }
  });
});